import { Auth } from "domain/model/Auth"
import { ProgressMeet, ProgressMeetFeedback, ProgressMeetFeedbackExternal } from "domain/model/ProgressMeet"
import ProgressMeetRepository from "domain/repository/Student/ProgressMeet"
import ProgressMeetDataSource from "data/dataSource/Student/ProgressMeetDataSource"
import { SaveProgressMeetFeedbackExternalUseCase } from "domain/useCase/Student/ProgressMeet/SaveProgressMeetFeedbackExternal"

export class ProgressMeetRepositoryImpl implements ProgressMeetRepository {
  private dataSource: ProgressMeetDataSource

  constructor(dataSource: ProgressMeetDataSource) {
    this.dataSource = dataSource
  }

  async getAllProgressMeets(auth: Auth): Promise<ProgressMeet[]> {
    try {
      return await this.dataSource.getAllProgressMeets(auth)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async saveProgressMeetFeedback(auth: Auth, feedback: ProgressMeetFeedback): Promise<void> {
    try {
      return await this.dataSource.saveProgressMeetFeedback(auth, feedback)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async saveProgressMeetFeedbackExternal(feedback: ProgressMeetFeedbackExternal): Promise<void> {
    try {
      return await this.dataSource.saveProgressMeetFeedbackExternal(feedback)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async getStudentProgressMeetFeedback(auth: Auth, meetingId: string): Promise<ProgressMeetFeedback> {
    try {
      return await this.dataSource.getStudentProgressMeetFeedback(auth, meetingId)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async getMentorshipStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getMentorshipStats(auth, batches, meetingDate)
  }
  async getClassAttendanceStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getClassAttendanceStats(auth, batches, meetingDate)
  }
  async getExamStats(auth: Auth, batches: string[], meetingDate: number): Promise<any> {
    return this.dataSource.getExamStats(auth, batches, meetingDate)
  }

  async captureProgressMeetAttendance(auth: Auth, meetingId: any): Promise<any> {
    try {
      return await this.dataSource.captureProgressMeetAttendance(auth, meetingId)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async fetchProgressMeetDetails(auth: Auth, meeting_id: any): Promise<any> {
    try {
      return await this.dataSource.fetchProgressMeetDetails(auth, meeting_id)
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async fetchProgressMeetStatus(auth: Auth, meeting_id: string): Promise<any> {
    try {
      return await this.dataSource.fetchProgressMeetStatus(auth, meeting_id)
    } catch (error) {
      throw new Error(`Failed to fetch progress meet status: ${error}`)
    }
  }
}
